import { useEffect, useState } from 'react'
import { getTokenTotalSupply } from '../../../api/tokens'

const useTotalSupply = (tokenId: string) => {
  const [totalSupply, setTotalSupply] = useState<string>('-1')
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchTotalSupply = async () => {
      try {
        setLoading(true)
        const response = await getTokenTotalSupply(tokenId)
        setTotalSupply(response.data.totalSupply)
        setError(null)
      } catch (err) {
        setError('Failed to load total supplies')
      } finally {
        setLoading(false)
      }
    }

    if (tokenId) {
      fetchTotalSupply()
    }
  }, [tokenId])

  return { totalSupply, loading, error }
}

export default useTotalSupply
